/* eslint-disable security/detect-object-injection */
/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable max-len */
import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react'
import CardHeader from '../../../components/CardHeader';
import { dataService } from '../../../services/data.services';
import { useNavigate, useParams } from 'react-router-dom';
import GlobalContext from '../../../components/Context/GlobalContext';
import { Tooltip } from 'react-tooltip';
import LoadingOverlay from "react-loading-overlay-ts";
// import { Tooltip } from 'react-tooltip';
import ModalBox from './Components/CustomModal'
import CardHeaders from '../../../components/CardHeaders';

export default function ViewOrders() {

    const [orderDetails, setOrdersDetails] = useState();
    const { id } = useParams()
    const [modalpopup, setmodalpopup] = useState({})
    const [updateLoading, setUpdateLoading] = useState(false)
    const [dataloading, setdataLoading] = useState(false)
    const { setToastmessage, setToastErrorMessage, setToastError, setToastWarning } = useContext(GlobalContext)
    const navigate = useNavigate();
    const [dependent, setDependent] = useState(false);

    const [note, setNote] = useState('');
    const [status, setStatus] = useState('');
    const [noteError, setNoteError] = useState('');

    const getOrderDetails = async () => {
        setdataLoading(true);
        try {
            const response = await dataService.GetAPI(`orders/${id}`)
            setOrdersDetails(response?.data?.data)
            console.log(response?.data?.data);
            setdataLoading(false)
        } catch (error) {
            if (error?.response?.status === 404) {
                setToastError('An Error Occured!')
                navigate('/my-store/customer-orders');
                setdataLoading(false);
            } else {
                setToastmessage('');
                setToastWarning('');
                setToastError('An Error Occured!')
            }
            setdataLoading(false);
        }
    }


    useEffect(() => {
        getOrderDetails();
        // console.log(orderDetails);
    }, []);

    const convertToDate = (timestamp, key) => {
        if (!timestamp) {
            return '-'
        }
        const date = new Date(timestamp * 1000); // Convert seconds to milliseconds

        // Format the date in the desired format
        if (key) {
            return date.toLocaleTimeString('en-US', { hour12: true });
        }
        return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    }

    const optionBasedOnStatus = (status) => {
        let options
        if (status === 'Pending') {
            options = ['Completed', 'Cancelled']
        } else if (status === 'Completed') {
            options = ['Returned']
        }
        return options
    }

    const changeOrderStatus = (orderId, currentStatus) => {
        if (currentStatus === 'Pending' || currentStatus === 'Completed') {
            setNote(orderDetails?.note)
            setmodalpopup({
                options: optionBasedOnStatus(currentStatus),
                open: true,
                title: 'Change Order Status',
                orderId,
                currentStatus,
            })
        }
    }

    const changeProductStatus = (productId, currentStatus, orderId) => {
        if (currentStatus === 'Pending' || currentStatus === 'Completed') {
            setNote(orderDetails?.note)
            setmodalpopup({
                options: optionBasedOnStatus(currentStatus),
                open: true,
                title: 'Change Product Status',
                productId,
                orderId,
                currentStatus,
            })
        }
    }

    const updateHandler = async () => {
        if (status?.trim() === '') {
            return;
        }
        if (note.length > 500) {
            setNoteError('Description too long. Max 500 characters.');
            return;
        }
        if (modalpopup?.title?.includes('Order')) {
            try {
                const body = {
                    order_status: status,
                    note,
                }
                setUpdateLoading(true);
                const response = await dataService.PatchAPI(body, `orders/update-order-status/${modalpopup.orderId}`)
                if (!response.error) {
                    setmodalpopup(prevState => {
                        return { ...prevState, open: false }
                    })
                    setStatus('');
                    setNote('');
                    getOrderDetails();
                }
                setUpdateLoading(false);
            } catch (error) {
                setUpdateLoading(false);

            }
        } else if (modalpopup?.title?.includes('Product')) {
            try {
                const body = {
                    product_status: status,
                    product_id: modalpopup.productId,
                    note,
                }
                setUpdateLoading(true);
                const response = await dataService.PatchAPI(body, `orders/update-product-status/${modalpopup.orderId}`)
                if (!response.error) {
                    setmodalpopup(prevState => {
                        return { ...prevState, open: false }
                    })
                    setStatus('');
                    setNote('');
                    getOrderDetails();
                }
                setUpdateLoading(false);
            } catch (error) {
                setUpdateLoading(false);

            }
        }

    }

    useLayoutEffect(() => {

    }, []);
    const totalGst = orderDetails?.total_gst !== undefined ? orderDetails.total_gst : 0;
    const formattedTotalGst = totalGst.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    console.log(formattedTotalGst);

    const store = JSON.parse(localStorage.getItem('Store'))
    return (
        <CardHeaders paths={['Orders / Purchases']} pathurls={['/orders-purchases']} activePath="Orders / Purchases Details" header="Orders / Purchases Details" back={-1}>
            <div className='bg-[#F5F5F5] px-4 py-[14px] relative  overflow-hidden'>
                <LoadingOverlay active={dataloading === true} spinner text="Fetching order details...">
                    <div className='w-full px-6 overflow-y-auto bg-white h-customh12 scrollBar'>
                        <div className='mt-[32px] flex items-center justify-between'>
                            <h1 data-testid="order-details" className='text-[#4B4B4B] font-playfair text-xl font-[600]'>Order Details</h1>
                        </div>
                        <div className='flex flex-col items-center gap-6 mt-6 '>
                            <div className='w-[100%] flex'>
                                <div className='w-1/5'>
                                    <p className='text-[#4B4B4B] text-sm font-normal mb-2 '>Order Number</p>
                                    <span data-testid="order-number" className='text-[#1f1f1f] text-sm font-[600]'>{orderDetails?.order_id || '-'}</span>
                                </div>
                                <div className='w-1/5'>
                                    <p className='text-[#4B4B4B] text-sm font-normal mb-2 '>Order Date</p>
                                    <span data-testid="order-date" className='text-[#1f1f1f] text-sm font-[600]'>{convertToDate(orderDetails?.created_at) || '-'}</span>
                                </div>
                                <div className='w-1/5'>
                                    <p className='text-[#4B4B4B] text-sm font-normal mb-2 '>Cart Number</p>
                                    <span className='text-[#1f1f1f] text-sm font-[600]' data-testid="cart-num">{orderDetails?.cart_number || '-'}</span>
                                </div>
                                <div className='w-1/5'>
                                    <p className='text-[#4B4B4B] text-sm font-normal mb-2 '>Number of Products</p>
                                    <span data-testid="number-of-product" className='text-[1f1f1f] text-sm font-[600]'>{(orderDetails?.products?.length) || '-'}</span>
                                </div>
                                <div className='w-1/5'>
                                    <p className='text-[#4B4B4B] text-sm font-normal mb-2 '>Customer Email</p>
                                    <span data-testid="customer-email-address" className='text-[#1f1f1f] text-sm font-[600] max-w-[300px] whitespace-nowrap break-words block overflow-hidden text-ellipsis'>
                                        {orderDetails?.customer_email_address || '-'}
                                    </span>
                                </div>
                            </div>

                            <div className='w-[100%] flex'>
                                <div className='w-1/5'>
                                    <p className='text-[#4B4B4B] text-sm font-normal mb-2 '>Merchant Name</p>
                                    <span data-testid="merchant-name" className='text-[#1f1f1f] text-sm font-[600] max-w-[300px] whitespace-nowrap break-words block overflow-hidden text-ellipsis capitalize'>
                                        {orderDetails?.merchant_name || '-'}
                                    </span>
                                </div>
                                <div className='w-1/5'>
                                    <p className='text-[#4B4B4B] text-sm font-normal mb-2 '>Store Name</p>
                                    <span data-testid="merchant-name" className='text-[#1f1f1f] text-sm font-[600] max-w-[300px] whitespace-nowrap break-words block overflow-hidden text-ellipsis'>
                                        {orderDetails?.store_name || '-'}
                                    </span>
                                </div>
                                <div className='w-1/5'>
                                    <p className='text-[#4B4B4B] text-sm font-normal mb-2 '>City</p>
                                    <span data-testid="city" className='text-[#1f1f1f] text-sm font-[600] max-w-[300px] whitespace-nowrap break-words block overflow-hidden text-ellipsis capitalize'>
                                        {orderDetails?.city || '-'}
                                    </span>
                                </div>
                                <div className='w-1/5'>
                                    <p className='text-[#4B4B4B] text-sm font-normal mb-2 '>Postal Code</p>
                                    <span className='text-[#1f1f1f] text-sm font-[600]' data-testid="postal-code">{orderDetails?.postal_code || '-'}</span>
                                </div>
                                <div className='w-1/5'>
                                    <p className='text-[#4B4B4B] text-sm font-normal mb-2 '>Payment Type</p>
                                    <span data-testid="order-payment-type" className='text-[#1f1f1f] text-sm font-[600]'>{orderDetails?.payment_method || orderDetails?.payment_type || '-'}</span>
                                </div>
                            </div>

                            <div className='w-[100%] flex'>

                                <div className='w-1/5'>
                                    <p className='text-[#4B4B4B] text-sm font-normal mb-2 '>Order Amount</p>
                                    <span data-testid="order-amount" className='text-[#1f1f1f] text-sm font-[600]'>{orderDetails?.order_amount ? `${orderDetails?.currency?.symbol ? orderDetails?.currency?.symbol : '$'}${Number(orderDetails?.order_amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '-'}</span>
                                </div>
                                <div className='w-1/5'>
                                    <p className='text-[#4B4B4B] text-sm font-normal mb-2 '>Currency</p>
                                    <span data-testid="order-amount" className='text-[#1f1f1f] text-sm font-[600]'>{orderDetails?.currency?.code ? orderDetails?.currency?.code : 'HKD'} - {orderDetails?.currency?.name ? orderDetails?.currency?.name : 'Hong Kong Dollar'}</span>
                                </div>
                                <div className='w-1/5'>
                                    <p className='text-[#4B4B4B] text-sm font-normal mb-2 '>Order Amount in Selected Currency</p>
                                    <span data-testid="order-amount" className='text-[#1f1f1f] text-sm font-[600]'>{`${(orderDetails?.crypto_amount && orderDetails?.crypto_coin) ? `${orderDetails?.crypto_amount || ''} ${orderDetails?.crypto_coin || ''}` : '-'}`}</span>
                                </div>
                                <div className='w-1/5'>
                                    <p className='text-[#4B4B4B] text-sm font-normal mb-2 '>Commission</p>
                                    <span data-testid="order-commission" className='text-[#1f1f1f] text-sm font-[600]'>{orderDetails?.currency?.symbol}{orderDetails?.commission ? orderDetails?.commission : '0'}</span>
                                </div>
                                <div className='w-1/5'>
                                    <div className='flex gap-3 mb-2'>
                                        <p className='text-[#4B4B4B] text-sm font-norma'>Transaction Status</p>
                                        {/* <img loading='Lazy' className={`${(orderDetails?.status === 'Cancelled' || orderDetails?.status === 'Returned') ? 'cursor-not-allowed' : ''}`} onClick={() => changeOrderStatus(orderDetails?._id, orderDetails?.status)} src='/assets/images/update_status.svg' /> */}
                                    </div>
                                    <span data-testid="order-status" className='text-[#1f1f1f] text-sm font-[600]'>{orderDetails?.payment_status || '-'}</span>
                                </div>
                            </div>

                        </div>


                        {orderDetails?.transaction_details && orderDetails?.transaction_details?.length > 0 && <div className='flex justify-between mt-8 mb-4'>
                            <h1 className='text-[#4B4B4B] font-playfair text-xl font-[600]'>Transaction Details</h1>
                        </div>}
                        {orderDetails?.transaction_details && orderDetails?.transaction_details?.length > 0 && orderDetails?.transaction_details?.map((item, i) => (
                            <div key={i}>
                                <div className='w-[100%] flex mb-6'>
                                    <div className='w-1/5'>
                                        <p className='text-[#4B4B4B] text-sm font-normal mb-2 '>Amount Paid</p>
                                        <span data-testid="order-number" className='text-[#1f1f1f] text-sm font-[600]'>{item?.amount_paid || '-'}</span>
                                    </div>
                                    <div className='w-1/5'>
                                        <p className='text-[#4B4B4B] text-sm font-normal mb-2 '>Transaction Date</p>
                                        <span data-testid="order-date" className='text-[#1f1f1f] text-sm font-[600]'>{item?.created_at ? (`${convertToDate(item?.created_at)} ${convertToDate(item?.created_at, 'time')}`) : '-'}</span>
                                    </div>
                                    <div className='w-1/5 mr-4'>
                                        <p className='text-[#4B4B4B] text-sm font-normal mb-2 '>Transaction Number</p>
                                        <span className='text-[#1f1f1f] text-sm font-[600]' data-testid="cart-num">{item?.transaction_number || '-'}</span>
                                    </div>
                                    <div className='w-2/5'>
                                        <p className='text-[#4B4B4B] text-sm font-normal mb-2 '>Transaction Hash</p>
                                        <span data-testid="number-of-product" className=' text-[1f1f1f] text-sm font-[600] w-full whitespace-nowrap break-words overflow-hidden text-ellipsis'>{(orderDetails?.crypto_amount || orderDetails?.crypto_coin) ? (item?.transaction_hash || '-') : '-'}</span>
                                    </div>
                                    {/* w-full whitespace-nowrap break-words block overflow-hidden text-ellipsis */}
                                    {/* <div className='w-1/5'>
                                <p className='text-[#4B4B4B] text-sm font-normal mb-2 '>Customer Email</p>
                                <span data-testid="customer-email-address" className='text-[#1f1f1f] text-sm font-[600] max-w-[300px] whitespace-nowrap break-words block overflow-hidden text-ellipsis'>
                                    {orderDetails?.customer_email_address || '-'}
                                </span>
                            </div> */}
                                </div>

                            </div>
                        ))
                        }
                        <div className='flex justify-between mt-8 mb-4'>
                            <h1 className='text-[#4B4B4B] font-playfair text-xl font-[600]'>Product Details</h1>
                        </div>
                        {!dataloading && orderDetails?.products?.length > 0 ? (
                            <>
                                <div className='border border-[#EB9DC7] p-4'>
                                    <table className='w-[95%]'>
                                        <thead className='pb-[9px]'>
                                            <tr>
                                                <th className='text-left text-sm pb-2 px-2 text-[#4B4B4B] font-normal'>
                                                    SKU
                                                </th>
                                                <th className='text-left text-sm pb-2 px-2 text-[#4B4B4B] font-normal'>
                                                    Product Name
                                                </th>
                                                <th className='text-right text-sm pb-2 px-2 text-[#4B4B4B] font-normal'>
                                                    Listing Price
                                                </th>
                                                <th className='text-sm text-right pb-2 px-2 text-[#4B4B4B] font-normal'>
                                                    Quantity
                                                </th>
                                                {/* <th className='text-right text-sm pb-2 px-2 text-[#4B4B4B] font-normal'>
                                                    Selling Price
                                                </th> */}
                                                <th className='text-sm text-right pb-2 px-2 text-[#4B4B4B] font-normal'>
                                                    Discount
                                                </th>
                                                <th className='text-sm text-right pb-2 px-2 text-[#4B4B4B] font-normal'>
                                                    GST
                                                </th>
                                                <th className='text-sm text-right pb-2 px-2 text-[#4B4B4B] font-normal'>
                                                    Item Total
                                                </th>

                                                {/* Dont remove the code it is change status code. */}
                                                {/* <th className='text-sm text-left pb-2 px-2 text-[#4B4B4B] font-normal'>
                                                    Status
                                                </th>
                                                <th className='text-sm text-left pb-2 px-2 text-[#4B4B4B] font-normal'>
                                                    Action
                                                </th> */}
                                            </tr>
                                        </thead>
                                        <tbody className='pt-2'>
                                            {orderDetails?.products?.map((item, index) => (
                                                <tr data-testid={`product-lists-${index}`} key={index} className={`pb-2 cursor-default`}>
                                                    <td title={item?.sku} data-tooltip-id={`sku-tooltip-${index}`} data-testid="sku" className={`text-[#1F1F1F] pb-2 px-2 text-sm font-[600] max-w-[200px] overflow-hidden text-ellipsis`}>
                                                        {item?.sku}
                                                        {/* <Tooltip
                                                            id={`sku-tooltip-${index}`}
                                                            place='bottom'
                                                            className='mt-[-15px]'
                                                            content={item?.sku}
                                                        /> */}
                                                    </td>
                                                    <td title={item?.name} data-tooltip-id={`product-name-tooltip-${index}`} data-testid="product_name" className={`text-[#1F1F1F] pb-2 px-2 text-sm font-[600] max-w-[600px] whitespace-nowrap break-words block overflow-hidden text-ellipsis`}>
                                                        {item?.name}
                                                        {/* <Tooltip
                                                            id={`product-name-tooltip-${index}`}
                                                            place='bottom'
                                                            content={item?.name}
                                                        /> */}
                                                    </td>
                                                    <td id='listingPrice' data-testid="listing_price" className={`text-[#1F1F1F] pb-2 px-2 text-right text-sm font-[600] max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap`} >
                                                        {`${orderDetails?.currency?.symbol ? orderDetails?.currency?.symbol : '$'}${item?.listing_price ? (Number(item?.listing_price)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}`}
                                                    </td>
                                                    <td data-testid="quantity" className={`${item?.is_deleted ? 'text-[#FC4523]' : (!item?.availability) ? 'text-[#1F1F1F] opacity-50 ' : 'text-[#1F1F1F]'} pb-2 text-right text-sm px-2 font-semibold max-w-[200px] overflow-hidden text-ellipsis`}>
                                                        {item?.quantity ? item?.quantity : 0}
                                                    </td>
                                                    {/* <td data-testid="selling_price" className={`text-[#1F1F1F] pb-2 px-2 text-right text-sm font-[600] max-w-[200px] overflow-hidden text-ellipsis`} >
                                                        {`$${(Number(item?.selling_price)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                                                    </td> */}
                                                    <td data-testid="discount" className={`text-[#1F1F1F] pb-2 px-2 text-right text-sm font-[600] max-w-[200px] overflow-hidden text-ellipsis`}>
                                                        {`${orderDetails?.currency?.symbol ? orderDetails?.currency?.symbol : '$'}${(item?.discount * item?.quantity) ? (Number(item?.discount * item?.quantity)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}`}
                                                    </td>
                                                    <td id='gst' data-testid="gst" className={`text-[#1F1F1F] pb-2 px-2 text-right text-sm font-[600] max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap`} >
                                                        {`${orderDetails?.currency?.symbol ? orderDetails?.currency?.symbol : '$'}${item.gst ? Number(item?.gst).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }): '0.00'}`}
                                                    </td>
                                                    <td data-testid="item_total" className={`text-[#1F1F1F] pb-2 px-2 text-right text-sm font-[600] max-w-[200px] overflow-hidden text-ellipsis`}>
                                                        {`${orderDetails?.currency?.symbol ? orderDetails?.currency?.symbol : '$'}${item?.item_total ? Number(item?.item_total).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}`}
                                                    </td>

                                                    {/* Dont remove the code it is change status code. */}
                                                    {/* <td className={`text-[#1F1F1F] pb-2 px-2 text-left text-sm font-[600] max-w-[200px] overflow-hidden text-ellipsis`}>
                                                        {item?.status || 'Pending'}
                                                    </td>
                                                    <td data-testid="action" className={`text-[#1F1F1F] pb-2 px-2 text-sm font-[600] text-center flex justify-start`}>
                                                        <img loading='Lazy' className={`${(item?.status === 'Cancelled' || item?.status === 'Returned') ? 'cursor-not-allowed' : ''}`} onClick={() => changeProductStatus(item?._id, (item?.status || 'Pending'), orderDetails._id)} src='/assets/images/edit.svg' />
                                                    </td> */}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className='w-[92%] '>
                                    <div className='flex flex-col items-end' >
                                        <div className='flex justify-start w-full'>
                                        </div>

                                        <div className='mb-2'>
                                            <div className='mb-[17px] mt-[24px]'>
                                                <h1 className='text-base text-left  w-full text-[#4b4b4b] font-normal'>Order Summary</h1>
                                            </div>
                                            <div className='flex items-center mb-2 space-x-6'>
                                                <h1 className='text-left text-sm text-[#4B4B4B] w-[246px]'>Sub Total (before discount)</h1>
                                                <span data-testid="order-sub-total" className='text-primary'>{`${orderDetails?.currency?.symbol ? orderDetails?.currency?.symbol : '$'}${orderDetails?.listed_amount ? Number(orderDetails?.listed_amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}`}</span>
                                            </div>
                                            <div className='flex items-center mb-2 space-x-6'>
                                                <h1 className='text-left text-sm text-[#4B4B4B] w-[246px]'>Total Discount</h1>
                                                <span data-testid="order-discount" className='text-primary'>{`${orderDetails?.currency?.symbol ? orderDetails?.currency?.symbol : '$'}${orderDetails?.order_discount ? Number(orderDetails?.order_discount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}`}</span>
                                            </div>
                                            <div className='flex items-center mb-2 space-x-6'>
                                                <h1 className='text-left text-sm text-[#4B4B4B] w-[246px]'>Total GST</h1>
                                                <span data-testid="order-discount" className='text-primary'>{`${orderDetails?.currency?.symbol ? orderDetails?.currency?.symbol : '$'}${formattedTotalGst}`}</span>
                                            </div>
                                            <div className='flex items-center mb-2 space-x-6'>
                                                <h1 className='text-left text-sm text-[#4B4B4B] w-[246px]'>Total amount (including discount & GST)</h1>
                                                <span data-testid="order-grand-total" className='text-primary'>{`${orderDetails?.currency?.symbol ? orderDetails?.currency?.symbol : '$'}${orderDetails?.order_amount ? Number(orderDetails?.order_amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}`}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : null}
                    </div>
                </LoadingOverlay>
            </div>
            <ModalBox
                open={modalpopup.open}
                title={modalpopup.title}
                options={modalpopup.options}
                setmodalpopup={setmodalpopup}
                setValue={setStatus}
                selectedValue={status}
                setNote={setNote}
                note={note}
                onUpdate={updateHandler}
                isLoading={updateLoading}
                noteError={noteError}
                setNoteError={setNoteError}
            />
        </CardHeaders>
    )
}

